import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { useNavigate, useParams } from 'react-router-dom';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function VideoDetailsPage() {
  const { id } = useParams();
  const [videoItem, setVideoItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // دالة استخراج معرف الفيديو من الرابط
  const getVideoId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  useEffect(() => {
    const fetchVideo = async () => {
      if (!id) {
        navigate('/videos');
        return;
      }
      
      try {
        const docRef = doc(db, 'videos', id);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setVideoItem(docSnap.data());
        } else {
          navigate('/videos');
        }
      } catch (error) {
        console.error("Error fetching video:", error);
        navigate('/videos');
      } finally {
        setLoading(false);
      }
    };
    
    fetchVideo();
  }, [id, navigate]);

  if (loading) {
    return (
      <div style={{ 
        padding: '20px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '50vh'
      }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center'
        }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #1e40af', 
            borderTopColor: 'transparent', 
            borderRadius: '50%', 
            animation: 'spin 1s linear infinite' 
          }}></div>
          <div style={{ marginTop: '16px', color: '#1e40af', fontWeight: '500' }}>
            جاري تحميل الفيديو...
          </div>
        </div>
      </div>
    );
  }

  if (!videoItem) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px', color: '#cbd5e1' }}>📹</div>
        <h2 style={{ color: '#1e40af' }}>الفيديو غير موجود</h2>
        <p style={{ color: '#64748b', marginTop: '8px' }}>
          قد يكون تم حذف هذا الفيديو أو نقله.
        </p>
        <button 
          onClick={() => navigate('/videos')}
          style={{
            marginTop: '20px',
            backgroundColor: '#1e40af',
            color: 'white',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '8px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          العودة لقائمة الفيديوهات
        </button>
      </div>
    );
  }

  const videoId = getVideoId(videoItem.video_url);

  return (
    <div style={{ 
      padding: '20px', 
      direction: 'rtl', 
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
      maxWidth: '900px',
      margin: '0 auto'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '24px'
      }}>
        <h1 style={{ color: '#1e40af', margin: 0, fontSize: '28px', fontWeight: '800' }}>
          {videoItem.title}
        </h1>
        <button 
          onClick={() => window.history.back()}
          style={{
            backgroundColor: '#1e40af',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          ← العودة
        </button>
      </div>

      {/* معلومات الفيديو */}
      <div style={{ 
        display: 'flex', 
        gap: '16px',
        marginBottom: '24px',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <div style={{ 
          backgroundColor: videoItem.category === 'beginner' ? '#fef3c7' : 
                         videoItem.category === 'analysis' ? '#dcfce7' : 
                         videoItem.category === 'signals' ? '#dbeafe' : '#f0fdf4',
          color: videoItem.category === 'beginner' ? '#92400e' : 
                  videoItem.category === 'analysis' ? '#166534' : 
                  videoItem.category === 'signals' ? '#1d4ed8' : '#065f46',
          padding: '6px 12px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          {videoItem.category === 'beginner' ? 'للمبتدئين' : 
           videoItem.category === 'analysis' ? 'التحليل' : 
           videoItem.category === 'signals' ? 'التوصيات' : 'للمتقدمين'}
        </div>
        {videoId && (
          <div style={{ color: '#64748b', fontSize: '14px' }}>
            المدة: <strong>10-15 دقيقة</strong> {/* يمكنك حسابها ديناميكيًا لاحقًا */}
          </div>
        )}
      </div>

      {/* مشغل الفيديو */}
      {videoId ? (
        <div style={{ 
          marginBottom: '24px', 
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          backgroundColor: 'black'
        }}>
          <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 */ }}>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0`}
              title={videoItem.title}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      ) : (
        <div style={{ 
          marginBottom: '24px', 
          backgroundColor: '#f1f5f9',
          borderRadius: '16px',
          padding: '40px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '48px', color: '#94a3b8' }}>📹</div>
          <p style={{ color: '#64748b', marginTop: '16px' }}>
            لا يمكن عرض هذا الفيديو
          </p>
        </div>
      )}

      {/* وصف الفيديو */}
      {videoItem.description && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '24px', 
          borderRadius: '16px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '16px',
          lineHeight: '1.8',
          color: '#1e293b'
        }}>
          <h3 style={{ color: '#1e40af', marginBottom: '16px', fontSize: '20px' }}>
            وصف الفيديو
          </h3>
          <p>{videoItem.description}</p>
        </div>
      )}

      {/* أزرار العمل */}
      <div style={{ 
        marginTop: '24px', 
        display: 'flex', 
        justifyContent: 'center',
        gap: '12px',
        flexWrap: 'wrap'
      }}>
        {videoItem.video_url && (
          <a
            href={videoItem.video_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: '#1e40af',
              color: 'white',
              textDecoration: 'none',
              padding: '10px 20px',
              borderRadius: '8px',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            🎥 شاهد على YouTube
          </a>
        )}
        <button
          onClick={() => {
            const url = window.location.href;
            navigator.clipboard.writeText(url).then(() => {
              alert('تم نسخ رابط الفيديو إلى الحافظة!');
            });
          }}
          style={{
            backgroundColor: '#f1f5f9',
            color: '#334155',
            border: '1px solid #e2e8f0',
            padding: '10px 20px',
            borderRadius: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          🔗 نسخ الرابط
        </button>
      </div>

      {/* أنماط CSS للتحميل الدوراني */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}